export default __webpack_public_path__ + "static/media/AcornMallFastFood_09.191c7ec4.png";